module.exports = __webpack_public_path__ + "img/BB.deac709f.png";